import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { ButtonBase, ButtonABase, } from './components';
export var buttonDefaultTopModelsObject = {
    ButtonBase: (React.createElement(TopModel, { name: "ButtonBase" }, ButtonBase)),
};
export var buttonADefaultTopModelsObject = {
    ButtonBase: (React.createElement(TopModel, { name: "ButtonBase" }, ButtonABase)),
};
